<template>
  <div class="ts-overflow-scroll ts-max-h-screen">
    <ts-table :columns="columns" :records="student">
      <template v-slot="{ record, index }">
        <td style="vertical-align: middle;">
          {{ index + 1 }}
        </td>
        <td style="vertical-align: middle;">{{ record.card_number }}</td>
        <td>
          <img
            class="ts-w-10 ts-rounded-sm ts-shadow-md"
            v-lazy="{
              src: photo(record),
              error: onError(),
              loading: require('@/assets/Rolling-1s-200px_2.svg')
            }"
          />
        </td>
        <td style="vertical-align: middle;">
          <b class="ts-text-blue-600">{{ record.full_name_en }}</b>
        </td>
        <td style="vertical-align: middle;">
          {{ record.gender }}
        </td>
        <td style="vertical-align: middle;">
          {{ record.date_of_birth }}
        </td>
        <td style="vertical-align: middle;">
          {{ record.phone }}
        </td>
      </template>
    </ts-table>
  </div>
</template>
<script>
export default {
  name: 'viewStudentList',
  props: ['student'],
  data() {
    return {
      photoError: require('../../../assets/user_default.png')
    }
  },
  computed: {
    columns() {
      return [
        {
          name: this.$t('school.academic.operation.classOperation.no')
        },
        {
          name: this.$t('school.academic.operation.classOperation.studentId'),
          sortKey: 'card_number'
        },
        {
          name: this.$t('school.academic.operation.classOperation.photo'),
          style: 'text-align:center'
        },
        {
          name: this.$t('school.academic.operation.classOperation.studentName'),
          sortKey: 'full_name_en'
        },
        {
          name: this.$t('school.academic.operation.classOperation.sex')
        },
        {
          name: this.$t('school.academic.operation.classOperation.dob')
        },
        {
          name: this.$t('school.academic.operation.classOperation.phone')
        }
      ]
    }
  },
  methods: {
    photo(record) {
      if (record.photo) {
        return record.photo
      }

      return this.photoError
    },
    onError() {
      event ? (event.target.src = this.photoError) : ''
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table thead tr th {
  text-transform: uppercase;
  padding: 4px 7px;
  background: rgb(218, 218, 218);
}
table tbody tr td {
  padding: 4px 7px;
}
</style>
